import axios, { AxiosInstance } from "axios";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { OpportunitiesApiService } from "@/services/OpportunitiesApiService";

class Service {

  public inviteToConnectNetworks(targetIds: string): Observable<number> {
    const url =
    `${process.env.VUE_APP_DISCOVERY_UI_BIO_URL}/api/genome/people/${targetIds}/invite`;

    return OpportunitiesApiService.post(url, {}).pipe(map((response) => {
      return response.status;
    }));
  }
}

export const ConnectionsService = new Service();
